import {CarePlanConfigurationFeature} from '../../../../../backend/enums/care-plan-configuration-feature';
import {
  RowData,
  ExportCarePlanGroupDataProcessor,
} from '../base/export-care-plan-group-data-processor';
import {translations} from '../../../../../i18n/translations';
import {ExportCarePlanTableColumnStyle} from '../base/export-care-plan-types';

export class CommonClinicalSupportXlsxDataProcessor extends ExportCarePlanGroupDataProcessor {
  override async resolveTaskHeaders(firstRowData: RowData): Promise<string[]> {
    const headers = firstRowData.entries.map((e) => e.name);
    const endDateHeader = this.t(
      translations.activity_type_posology_schedule_form.fields.end_date.label
    );
    const endHourHeader = this.t(
      translations.activity_type_posology_schedule_form.fields.end_hour.label
    );

    return this.reorderCells(headers, endDateHeader, endHourHeader);
  }

  override resolveTaskRow(rowData: RowData) {
    const cells: string[] = [];
    let endDateCell: string = '';
    let endHourCell: string = '';

    for (const entry of rowData.entries) {
      switch (entry.feature) {
        case CarePlanConfigurationFeature.Schedule: {
          const {periodicity, endDate, endHour} = this.resolveEntryCellSchedule(entry);
          cells.push(periodicity);
          endDateCell = endDate;
          endHourCell = endHour;
          break;
        }

        default:
          cells.push(this.resolveEntryCell(entry));
          break;
      }
    }

    return this.reorderCells(cells, endDateCell, endHourCell);
  }

  override resolveTasksColumnStyles(
    taskHeaders: string[]
  ): ExportCarePlanTableColumnStyle | undefined {
    // console.log('headers', taskHeaders);
    // 0: "Ativa"
    // 1: "Registo obrigatório"
    // 2: "Hora de início"
    // 3: "Data de início"
    // 4: "Data Fim"
    // 5: "Hora fim"
    // 6: "Nome da tarefa"
    // 7: "Repetição"
    // 8: "Observações"
    // 9: "Turnos"
    // 10: "Planear"

    return {
      0: {cellWidth: 10},
      1: {cellWidth: 20},
      5: {cellWidth: 30},
      6: {cellWidth: 30},
      7: {cellWidth: 30},
      8: {cellWidth: 25},
      9: {cellWidth: 10},
    };
  }
}
